// extracted by mini-css-extract-plugin
export default {"mCard":"dD-z","image":"eD-z","imageNoBackground":"fD-z","imageHasCategory":"gD-z","fullWidth":"hD-z"};